import React, { createContext, useContext, useState, useEffect } from 'react'
import { openDB } from 'idb'

const DB_NAME = 'DiagnosisDB'
const DB_VERSION = 1

// Stores
const HPI_MASTER_DIAGNOSIS_STORE = 'HPIMaster'
const PE_STORE = 'peData'
const ASSESMENT_SUGGESTION_STORE = 'assSuggMaster'
const GENERAL_PLAN_STATEMENT_STORE = 'generalPlanStatement'
const DIFFERENTIAL_DIAGNOSIS_SUGGESTION_STORE = 'differentialDiagnosisSuggestion'
const INTERNAL_NOTES_STORE = 'internalNotes'
const MASTER_EDUCATION_STORE = 'masterEducation'
const POA_QUESTION_STORE = 'poaQestion'
const IMAGING_MASTER_STORE = 'imagingMaster'
const IMAGING_DETAILS_STORE = 'imagingDetails'
const LAB_MASTER_STORE = 'labMaster'
const MEDICATION_MASTER_STORE = 'medicationMaster'
const MISCELLANEOUS_MASTER_STORE = 'miscellaneousMaster'
const RISK_FACTOR_STORE = 'riskFactor'
const ALL_DIAGNOSIS_STORE = 'allDiagnosis'
const ALL_DIAGNOSIS_OPTIONS_STORE = 'allDiagnosisOptions'
const OFFLINE_STORE_APPOINTMENT_DATA = 'offlineAppointmentData'
const POAC_MASTER_STORE = 'poacmaster'
const PROVIDER_DETAILS_STORE = 'providerDetails'
const PROVIDER_LIST_STORE = 'providerList'
const FACILITY_STORE = 'facilityData'
const ALL_PATIENT_HPI_STORE = 'allPatientHPI'
const AllAPPOINTMENTDATA_STORE = 'allappointmentdata'
const PATIENT_TODAYS_APPOINTMENT_STORE = 'todaysAppointment'
const DIAGNOSIS_RESPONSE_STORE = 'getDiagnosisResponse'
const GET_ALL_ADDENDUM_STORE = 'getAllAddendumStore'
const ALL_IMAGING_DATA_STORE = 'allImagingData'
const ALL_MEDICATION_RES_DATA_STORE = 'allMedicationResData'
const ALLAPPOINTMENTDETAILS_STORE = 'allAppointmentDetails'
const ALL_PATIENT_DETAILS_STORE = 'allPatientDetails'
const OFFLINE_STORE_OPENCHART_APPOINTMENT_DATA = 'offlineOpenChartAppointment'
const ALL_OPENCHART_APPOINTMENT_DATA_STORE = 'allOpenChartAppointment'
const ALL_TEST_PATIENT_STORE = 'allTestPatient'
const NEW_PATIENT_DATA_STORE = 'addonPatient'
const NEW_PATIENT_HPI_STORE = 'newPatientHPI'
const CALL_CENTER_QUESTIONS_STORE = 'callCenterQuestions'
const STORE_PRE_SIGNED_DATA_STORE = 'storePreSignedData'
const PRE_SIGNED_ALL_APPOINTMENT_STORE = 'preSignedTodaysAppointment'

// Keys
const HPI_DATA_KEY = 'hpidata'
const PE_KEY = 'peData'
const ASSESMENT_SUGGESTION_KEY = 'assSuggMaster'
const GENERAL_PLAN_STATEMENT_KEY = 'generalPlanStatement'
const DIFFERENTIAL_DIAGNOSIS_SUGGESTION_KEY = 'differentialDiagnosisSuggestion'
const INTERNAL_NOTES_KEY = 'internalNotes'
const MASTER_EDUCATION_KEY = 'masterEducation'
const POA_QUESTION_KEY = 'poaQestion'
const IMAGING_MASTER_KEY = 'imagingMaster'
const LAB_MASTER_KEY = 'labMaster'
const MEDICATION_MASTER_KEY = 'medicationMaster'
const MISCELLANEOUS_MASTER_KEY = 'miscellaneousMaster'
const RISK_FACTOR_KEY = 'riskFactor'
const ALL_DIAGNOSIS_KEY = 'allDiagnosis'
const ALL_DIAGNOSIS_OPTIONS_KEY = 'allDiagnosisOptions'
const OFFLINE_APPOINTMENT_DATA_KEY = 'offlineAppointmentData'
const IMAGING_DETAILS_KEY = 'imagingDetails'
const POAC_MASTER_KEY = 'poacmaster'
const PROVIDER_DETAILS_KEY = 'providerDetails'
const PROVIDER_LIST_KEY = 'providerList'
const FACILITY_KEY = 'facilityData'
const ALL_PATIENT_HPI_KEY = 'allPatientHPI'
const AllAPPOINTMENTDATA_KEY = 'allappointmentdata'
const PATIENT_TODAYS_APPOINTMENT_KEY = 'todaysAppointment'
const DIAGNOSIS_RESPONSE_KEY = 'getDiagnosisResponse'
const GET_ALL_ADDENDUM_KEY = 'getAllAddendumKey'
const GET_ALL_IMAGING_DATA_KEY = 'getAllImagingDataKey'
const GET_ALL_MEDICATION_RES_DATA_KEY = 'getAllMedicationResDataKey'
const ALLAPPOINTMENTDETAILS_KEY = 'allAppointmentDetails'
const ALL_PATIENT_DETAILS_KEY = 'allPatientDetails'
const OFFLINE_KEY_OPENCHART_APPOINTMENT_DATA = 'offlineOpenChartAppointment'
const ALL_OPENCHART_APPOINTMENT_DATA_KEY = 'allOpenChartAppointment'
const ALL_TEST_PATIENT_KEY = 'allTestPatient'
const NEW_PATIENT_DATA_KEY = 'addonPatient'
const NEW_PATIENT_HPI_KEY = 'newPatientHPI'
const CALL_CENTER_QUESTIONS_KEY = 'callCenterQuestions'
const STORE_PRE_SIGNED_DATA_KEY = 'storePreSignedData'
const PRE_SIGNED_ALL_APPOINTMENT_KEY = 'preSignedTodaysAppointment'

const IndexedDBContext = createContext()

export const useIndexedDB = () => useContext(IndexedDBContext)

export const IndexedDBProvider = ({ children }) => {
  const [db, setDb] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dbReady, setDbReady] = useState(false)

  const initDB = async () => {
    try {
      setDbReady(false)

      const dbs = await indexedDB.databases()
      const existingDB = dbs.find((db) => db.name === DB_NAME)
      const currentVersion = existingDB?.version || 0

      const REQUIRED_STORES = [
        HPI_MASTER_DIAGNOSIS_STORE,
        PE_STORE,
        ASSESMENT_SUGGESTION_STORE,
        GENERAL_PLAN_STATEMENT_STORE,
        DIFFERENTIAL_DIAGNOSIS_SUGGESTION_STORE,
        INTERNAL_NOTES_STORE,
        MASTER_EDUCATION_STORE,
        POA_QUESTION_STORE,
        RISK_FACTOR_STORE,
        ALL_DIAGNOSIS_STORE,
        ALL_DIAGNOSIS_OPTIONS_STORE,
        POAC_MASTER_STORE,
        AllAPPOINTMENTDATA_STORE,
        PROVIDER_LIST_STORE,
        FACILITY_STORE,
        ALL_PATIENT_HPI_STORE,
        IMAGING_MASTER_STORE,
        PROVIDER_DETAILS_STORE,
        OFFLINE_STORE_APPOINTMENT_DATA,
        IMAGING_DETAILS_STORE,
        LAB_MASTER_STORE,
        MEDICATION_MASTER_STORE,
        MISCELLANEOUS_MASTER_STORE,
        PATIENT_TODAYS_APPOINTMENT_STORE,
        DIAGNOSIS_RESPONSE_STORE,
        GET_ALL_ADDENDUM_STORE,
        ALL_IMAGING_DATA_STORE,
        ALL_MEDICATION_RES_DATA_STORE,
        ALLAPPOINTMENTDETAILS_STORE,
        ALL_PATIENT_DETAILS_STORE,
        OFFLINE_STORE_OPENCHART_APPOINTMENT_DATA,
        ALL_OPENCHART_APPOINTMENT_DATA_STORE,
        ALL_TEST_PATIENT_STORE,
        NEW_PATIENT_DATA_STORE,
        NEW_PATIENT_HPI_STORE,
        CALL_CENTER_QUESTIONS_STORE,
        STORE_PRE_SIGNED_DATA_STORE,
        PRE_SIGNED_ALL_APPOINTMENT_STORE,
      ]

      //   DB does not exist — create all stores
      if (!existingDB) {
        const database = await openDB(DB_NAME, DB_VERSION, {
          upgrade(db) {
            REQUIRED_STORES.forEach((store) => {
              if (!db.objectStoreNames.contains(store)) {
                db.createObjectStore(store)
              }
            })
          },
        })

        await database.done
        setDb(database)
        setDbReady(true)
        return
      }

      //   DB exists — open and check for missing stores
      const tempDB = await openDB(DB_NAME, currentVersion)
      const missingStores = REQUIRED_STORES.filter((store) => !tempDB.objectStoreNames.contains(store))

      if (missingStores.length === 0) {
        await tempDB.done
        setDb(tempDB)
        setDbReady(true)
        return
      }

      //   Some stores missing — upgrade version safely

      const newVersion = currentVersion + 1
      tempDB.close()

      const upgradedDB = await openDB(DB_NAME, newVersion, {
        upgrade(db) {
          missingStores.forEach((store) => {
            if (!db.objectStoreNames.contains(store)) {
              db.createObjectStore(store)
            }
          })
        },
      })

      await upgradedDB.done
      setDb(upgradedDB)
      setDbReady(true)
    } catch (err) {
      setDbReady(false)
    }
  }

  useEffect(() => {
    initDB()
  }, [])

  useEffect(() => {
    if (db) {
      checkIfMastersExist()
    }
  }, [db])

  //   const waitForDB = async () => {
  //   if (dbReady && db) return db
  //   while (!dbReady) {
  //     await new Promise((res) => setTimeout(res, 100))
  //   }
  //   return db
  // }

  //   const saveData = async (storeName, key, value) => {
  //     if (!db) return;
  //     // await ensureStoreExists(storeName)
  //     setLoading(true);
  //     try {
  //       await db.put(storeName, value, key);
  //     } catch (e){
  //          console.log("error-->" , e)
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   const getData = async (storeName, key) => {
  //     if (!db) return null;
  //     // await ensureStoreExists(storeName)
  //     return await db.get(storeName, key);
  //   };

  // 🧩 Waits until db is ready before returning it
  const waitForDB = async () => {
    if (db && dbReady) return db

    let waited = 0
    while ((!db || !dbReady) && waited < 5000) {
      await new Promise((resolve) => setTimeout(resolve, 100))
      waited += 100
    }

    if (!db || !dbReady) {
      console.warn(' DB was not ready after 5s — reinitializing...')
      await initDB()
    }

    return db
  }

  const saveData = async (storeName, key, value) => {
    setLoading(true)

    const activeDB = await waitForDB()

    try {
      await activeDB.put(storeName, value, key)
    } catch (err) {
      console.error(` Error saving ${key} in ${storeName}:`, err)

      if (err.name === 'InvalidStateError' || err.message?.includes('closing')) {
        console.warn(' Retrying save after DB reconnect...')
        await initDB()
        const retryDB = await waitForDB()
        await retryDB.put(storeName, value, key)
      }
    } finally {
      setLoading(false)
    }
  }

  const getData = async (storeName, key) => {
    const activeDB = await waitForDB()

    try {
      const result = await activeDB.get(storeName, key)
      return result
    } catch (err) {
      console.error(` Error reading ${key} from ${storeName}:`, err)

      // Retry if DB connection was closing
      if (err.name === 'InvalidStateError' || err.message?.includes('closing')) {
        console.warn(' Retrying get after DB reconnect...')
        await initDB()
        const retryDB = await waitForDB()
        return await retryDB.get(storeName, key)
      }

      return null
    }
  }

  const checkIfMastersExist = async () => {
    if (!db) return false
    try {
      const imaging = await db.get(IMAGING_MASTER_STORE, IMAGING_MASTER_KEY)
      const lab = await db.get(LAB_MASTER_STORE, LAB_MASTER_KEY)
      const medication = await db.get(MEDICATION_MASTER_STORE, MEDICATION_MASTER_KEY)
      const education = await db.get(MASTER_EDUCATION_STORE, MASTER_EDUCATION_KEY)
      const misc = await db.get(MISCELLANEOUS_MASTER_STORE, MISCELLANEOUS_MASTER_KEY)
      const assSugg = await db.get(ASSESMENT_SUGGESTION_STORE, ASSESMENT_SUGGESTION_KEY)
      const hpiDiagnosis = await db.get(HPI_MASTER_DIAGNOSIS_STORE, HPI_DATA_KEY)
      const generalPlan = await db.get(GENERAL_PLAN_STATEMENT_STORE, GENERAL_PLAN_STATEMENT_KEY)
      const diffDiagnosis = await db.get(DIFFERENTIAL_DIAGNOSIS_SUGGESTION_STORE, DIFFERENTIAL_DIAGNOSIS_SUGGESTION_KEY)
      const riskFactor = await db.get(RISK_FACTOR_STORE, RISK_FACTOR_KEY)
      const allDiagnosis = await db.get(ALL_DIAGNOSIS_STORE, ALL_DIAGNOSIS_KEY)
      const allDiagnosisOptions = await db.get(ALL_DIAGNOSIS_OPTIONS_STORE, ALL_DIAGNOSIS_OPTIONS_KEY)
      const PE = await db.get(PE_STORE, PE_KEY)
      const offline = await db.get(OFFLINE_STORE_APPOINTMENT_DATA, OFFLINE_APPOINTMENT_DATA_KEY)
      const imagingDetails = await db.get(IMAGING_DETAILS_STORE, IMAGING_DETAILS_KEY)
      const poacMaster = await db.get(POAC_MASTER_STORE, POAC_MASTER_KEY)
      const providerDetails = await db.get(PROVIDER_DETAILS_STORE, PROVIDER_DETAILS_KEY)
      const allPatientHPI = await db.get(ALL_PATIENT_HPI_STORE, ALL_PATIENT_HPI_KEY)
      const providerList = await db.get(PROVIDER_LIST_STORE, PROVIDER_LIST_KEY)
      const facility = await db.get(FACILITY_STORE, FACILITY_KEY)
      const AllAppointmentData = await db.get(AllAPPOINTMENTDATA_STORE, AllAPPOINTMENTDATA_KEY)
      const diagnosisReponseData = await db.get(DIAGNOSIS_RESPONSE_STORE, DIAGNOSIS_RESPONSE_KEY)
      const allImagingDatas = await db.get(ALL_IMAGING_DATA_STORE, GET_ALL_IMAGING_DATA_KEY)
      const allMedsDatasRes = await db.get(ALL_MEDICATION_RES_DATA_STORE, GET_ALL_MEDICATION_RES_DATA_KEY)
      const allAppointmentDetails = await db.get(ALLAPPOINTMENTDETAILS_STORE, ALLAPPOINTMENTDETAILS_KEY)
      const allPatientDetails = await db.get(ALL_PATIENT_DETAILS_STORE, ALL_PATIENT_DETAILS_KEY)
      const callCenterQuestions = await db.get(CALL_CENTER_QUESTIONS_STORE, CALL_CENTER_QUESTIONS_KEY)

      // const keys = {
      //   imaging,
      //   lab,
      //   medication,
      //   education,
      //   misc,
      //   assSugg,
      //   hpiDiagnosis,
      //   generalPlan,
      //   diffDiagnosis,
      //   riskFactor,
      //   allDiagnosis,
      //   allDiagnosisOptions,
      //   PE,
      //   imagingDetails,
      //   poacMaster,
      //   providerDetails,
      //   facility,
      //   // allPatientHPI,
      //   AllAppointmentData,
      //   diagnosisReponseData,
      //   allAppointmentDetails,
      // };

      return Boolean(
        imaging &&
        lab &&
        medication &&
        education &&
        misc &&
        assSugg &&
        hpiDiagnosis &&
        generalPlan &&
        diffDiagnosis &&
        riskFactor &&
        allDiagnosis &&
        allDiagnosisOptions &&
        PE &&
        imagingDetails &&
        poacMaster &&
        providerDetails &&
        facility &&
        // allPatientHPI &&
        AllAppointmentData &&
        diagnosisReponseData &&
        allAppointmentDetails &&
        callCenterQuestions,
      )
    } catch (error) {
      console.error('Error checking IndexedDB master data:', error)
      return false
    }
  }

  // useEffect(() => {
  //   checkIfMastersExist()
  // }, [])

  return (
    <IndexedDBContext.Provider
      value={{
        loading,
        saveHPIDiagnosisData: (data) => {
          saveData(HPI_MASTER_DIAGNOSIS_STORE, HPI_DATA_KEY, data)
        },
        savePEData: (data) => saveData(PE_STORE, PE_KEY, data),
        getHPIDiagnosisData: () => getData(HPI_MASTER_DIAGNOSIS_STORE, HPI_DATA_KEY),
        getPEData: () => getData(PE_STORE, PE_KEY),
        saveAssSuggMasterData: (data) => saveData(ASSESMENT_SUGGESTION_STORE, ASSESMENT_SUGGESTION_KEY, data),
        getAssSuggMasterData: () => getData(ASSESMENT_SUGGESTION_STORE, ASSESMENT_SUGGESTION_KEY),
        saveGeneralPlanStatement: (data) => saveData(GENERAL_PLAN_STATEMENT_STORE, GENERAL_PLAN_STATEMENT_KEY, data),
        getGeneralPlanStatement: () => getData(GENERAL_PLAN_STATEMENT_STORE, GENERAL_PLAN_STATEMENT_KEY),
        saveDifferntialDiagnosis: (data) => saveData(DIFFERENTIAL_DIAGNOSIS_SUGGESTION_STORE, DIFFERENTIAL_DIAGNOSIS_SUGGESTION_KEY, data),
        getDifferentialDiagnosis: () => getData(DIFFERENTIAL_DIAGNOSIS_SUGGESTION_STORE, DIFFERENTIAL_DIAGNOSIS_SUGGESTION_KEY),
        saveInternalnote: (data) => saveData(INTERNAL_NOTES_STORE, INTERNAL_NOTES_KEY, data),
        getInternalnote: () => getData(INTERNAL_NOTES_STORE, INTERNAL_NOTES_KEY),
        saveEducationMaster: (data) => saveData(MASTER_EDUCATION_STORE, MASTER_EDUCATION_KEY, data),
        getEducationMaster: () => getData(MASTER_EDUCATION_STORE, MASTER_EDUCATION_KEY),
        savePoaQuestion: (data) => saveData(POA_QUESTION_STORE, POA_QUESTION_KEY, data),
        getPoaQuestion: () => getData(POA_QUESTION_STORE, POA_QUESTION_KEY),

        saveImagingMasterData: (data) => saveData(IMAGING_MASTER_STORE, IMAGING_MASTER_KEY, data),
        getImagingMasterData: () => getData(IMAGING_MASTER_STORE, IMAGING_MASTER_KEY),

        saveLabMasterData: (data) => saveData(LAB_MASTER_STORE, LAB_MASTER_KEY, data),
        getLabMasterData: () => getData(LAB_MASTER_STORE, LAB_MASTER_KEY),

        saveMedicationMasterData: (data) => saveData(MEDICATION_MASTER_STORE, MEDICATION_MASTER_KEY, data),
        getMedicationMasterData: () => getData(MEDICATION_MASTER_STORE, MEDICATION_MASTER_KEY),

        saveMiscellaneousMaster: (data) => saveData(MISCELLANEOUS_MASTER_STORE, MISCELLANEOUS_MASTER_KEY, data),
        getMiscellaneousMaster: () => getData(MISCELLANEOUS_MASTER_STORE, MISCELLANEOUS_MASTER_KEY),

        saveRiskFactorMaster: (data) => saveData(RISK_FACTOR_STORE, RISK_FACTOR_KEY, data),
        getRiskFactorMaster: () => getData(RISK_FACTOR_STORE, RISK_FACTOR_KEY),

        saveAllMasterDiagnosis: (data) => saveData(ALL_DIAGNOSIS_STORE, ALL_DIAGNOSIS_KEY, data),
        getAllMasterDiagnosis: () => getData(ALL_DIAGNOSIS_STORE, ALL_DIAGNOSIS_KEY),

        saveOfflineData: (data) => saveData(OFFLINE_STORE_APPOINTMENT_DATA, OFFLINE_APPOINTMENT_DATA_KEY, data),
        getOfflineData: () => getData(OFFLINE_STORE_APPOINTMENT_DATA, OFFLINE_APPOINTMENT_DATA_KEY),

        saveImagingDetailsAllMaster: (data) => saveData(IMAGING_DETAILS_STORE, IMAGING_DETAILS_KEY, data),
        getImagingDetailsAllMaster: () => getData(IMAGING_DETAILS_STORE, IMAGING_DETAILS_KEY),

        saveProviderDetails: (data) => saveData(PROVIDER_DETAILS_STORE, PROVIDER_DETAILS_KEY, data),
        getProviderDetails: () => getData(PROVIDER_DETAILS_STORE, PROVIDER_DETAILS_KEY),

        savePatientHpi: (data) => saveData(ALL_PATIENT_HPI_STORE, ALL_PATIENT_HPI_KEY, data),
        getPatientHpi: () => getData(ALL_PATIENT_HPI_STORE, ALL_PATIENT_HPI_KEY),

        saveAllAppointmentData: (data) => saveData(AllAPPOINTMENTDATA_STORE, AllAPPOINTMENTDATA_KEY, data),
        getAllAppointmentData: () => getData(AllAPPOINTMENTDATA_STORE, AllAPPOINTMENTDATA_KEY),

        savePOACMaster: (data) => {
          saveData(POAC_MASTER_STORE, POAC_MASTER_KEY, data)
        },
        getPOACMaster: () => getData(POAC_MASTER_STORE, POAC_MASTER_KEY),

        saveProviderList: (data) => saveData(PROVIDER_LIST_STORE, PROVIDER_LIST_KEY, data),
        getProviderList: () => getData(PROVIDER_LIST_STORE, PROVIDER_LIST_KEY),

        saveFacilityData: (data) => saveData(FACILITY_STORE, FACILITY_KEY, data),
        getFacilityData: () => getData(FACILITY_STORE, FACILITY_KEY),

        saveAllMasterDiagnosisOptions: (data) => saveData(ALL_DIAGNOSIS_OPTIONS_STORE, ALL_DIAGNOSIS_OPTIONS_KEY, data),
        getAllMasterDiagnosisOptions: () => getData(ALL_DIAGNOSIS_OPTIONS_STORE, ALL_DIAGNOSIS_OPTIONS_KEY),

        saveAllTodaysAppointment: (data) => saveData(PATIENT_TODAYS_APPOINTMENT_STORE, PATIENT_TODAYS_APPOINTMENT_KEY, data),
        getAllTodaysAppointment: () => getData(PATIENT_TODAYS_APPOINTMENT_STORE, PATIENT_TODAYS_APPOINTMENT_KEY),

        saveDiagnosisReponseData: (data) => saveData(DIAGNOSIS_RESPONSE_STORE, DIAGNOSIS_RESPONSE_KEY, data),
        getDiagnosisReponseData: () => getData(DIAGNOSIS_RESPONSE_STORE, DIAGNOSIS_RESPONSE_KEY),

        saveAddedEndumen: (data) => saveData(GET_ALL_ADDENDUM_STORE, GET_ALL_ADDENDUM_KEY, data),
        getAddedEndumen: () => getData(GET_ALL_ADDENDUM_STORE, GET_ALL_ADDENDUM_KEY),

        saveImagingInformationData: (data) => saveData(ALL_IMAGING_DATA_STORE, GET_ALL_IMAGING_DATA_KEY, data),
        getImagingInformationData: () => getData(ALL_IMAGING_DATA_STORE, GET_ALL_IMAGING_DATA_KEY),

        saveMedicationinformationData: (data) => saveData(ALL_MEDICATION_RES_DATA_STORE, GET_ALL_MEDICATION_RES_DATA_KEY, data),
        getMedicationinformationData: () => getData(ALL_MEDICATION_RES_DATA_STORE, GET_ALL_MEDICATION_RES_DATA_KEY),

        saveAllAppointmentDetails: (data) => saveData(ALLAPPOINTMENTDETAILS_STORE, ALLAPPOINTMENTDETAILS_KEY, data),
        getAllAppointmentDetails: () => getData(ALLAPPOINTMENTDETAILS_STORE, ALLAPPOINTMENTDETAILS_KEY),

        savePatientDetails: (data) => saveData(ALL_PATIENT_DETAILS_STORE, ALL_PATIENT_DETAILS_KEY, data),
        getPatientDetails: () => getData(ALL_PATIENT_DETAILS_STORE, ALL_PATIENT_DETAILS_KEY),

        saveOpenChartOfflineData: (data) => saveData(OFFLINE_STORE_OPENCHART_APPOINTMENT_DATA, OFFLINE_KEY_OPENCHART_APPOINTMENT_DATA, data),
        getOpenChartOfflineData: () => getData(OFFLINE_STORE_OPENCHART_APPOINTMENT_DATA, OFFLINE_KEY_OPENCHART_APPOINTMENT_DATA),

        saveOpenChartAppointmentData: (data) => saveData(ALL_OPENCHART_APPOINTMENT_DATA_STORE, ALL_OPENCHART_APPOINTMENT_DATA_KEY, data),
        getOpenChartAppointmentData: () => getData(ALL_OPENCHART_APPOINTMENT_DATA_STORE, ALL_OPENCHART_APPOINTMENT_DATA_KEY),
        saveTestOfflineData: (data) => saveData(ALL_TEST_PATIENT_STORE, ALL_TEST_PATIENT_KEY, data),
        getTestOfflineData: () => getData(ALL_TEST_PATIENT_STORE, ALL_TEST_PATIENT_KEY),

        saveNewPatientData: (data) => saveData(NEW_PATIENT_DATA_STORE, NEW_PATIENT_DATA_KEY, data),
        getNewPatientData: () => getData(NEW_PATIENT_DATA_STORE, NEW_PATIENT_DATA_KEY),

        saveNewPatientHPI: (data) => saveData(NEW_PATIENT_HPI_STORE, NEW_PATIENT_HPI_KEY, data),
        getNewPatientHPI: () => getData(NEW_PATIENT_HPI_STORE, NEW_PATIENT_HPI_KEY),

        saveCallCenterQuestions: (data) => saveData(CALL_CENTER_QUESTIONS_STORE, CALL_CENTER_QUESTIONS_KEY, data),
        getCallCenterQuestions: () => getData(CALL_CENTER_QUESTIONS_STORE, CALL_CENTER_QUESTIONS_KEY),

        savePreSignedData: (data) => saveData(STORE_PRE_SIGNED_DATA_STORE, STORE_PRE_SIGNED_DATA_KEY, data),
        getPreSignedData: () => getData(STORE_PRE_SIGNED_DATA_STORE, STORE_PRE_SIGNED_DATA_KEY),

        savePreSignedAppointment: (data) => saveData(PRE_SIGNED_ALL_APPOINTMENT_STORE, PRE_SIGNED_ALL_APPOINTMENT_KEY, data),
        getPreSignedAppointment: () => getData(PRE_SIGNED_ALL_APPOINTMENT_STORE, PRE_SIGNED_ALL_APPOINTMENT_KEY),

        checkIfMastersExist,
      }}
    >
      {children}
    </IndexedDBContext.Provider>
  )
}

export default IndexedDBProvider
